import { useEffect, useMemo, useState } from 'react';

import {
  DEFAULT_COEFFICENT,
  PRICE,
  QUOTE_INSTALLER_TYPES,
  SOURCE,
  VAT,
} from '@/common/constants';

/**
 * GetQuote
 * DeleteQuote
 * ModifyItem
 * ToggleSelect
 * @param Children
 * @returns {function(*)}
 */
const useManageQuoteContext = ({ formatedQuote }) => {
  const [contextFormatedQuote, setContextFormatedQuote] = useState(null);

  useEffect(() => {
    if (formatedQuote) {
      setContextFormatedQuote(formatedQuote);
    }
  }, [formatedQuote]);

  /**
   * Format quote_lines to fit the addTo payload
   * @returns {array}
   */
  const formatAddTo = useMemo(() => {
    if (!contextFormatedQuote || !contextFormatedQuote.quote_lines) {
      return null; // Si quote ou quote_lines est null ou undefined, retourne directement quote
    }
    const cartItems = [];
    contextFormatedQuote.quote_lines.forEach((quoteLine) => {
      if (
        quoteLine.is_selected &&
        quoteLine.type === QUOTE_INSTALLER_TYPES.PRODUCT
      ) {
        cartItems.push({
          coefficient: DEFAULT_COEFFICENT,
          label: quoteLine.product?.name || quoteLine.supplier_name,
          quantity: quoteLine.quantity,
          sku: quoteLine.product?.main_sku || quoteLine.product_id,
          quote_line: quoteLine.id,
          quote_number: contextFormatedQuote.number,
          quote_sequence: contextFormatedQuote.sequence,
          type: quoteLine.type,
          type_price: PRICE.NET,
          unit_price:
            quoteLine.net_price ||
            quoteLine.product?.price_and_stock?.price?.customer_price ||
            quoteLine.price, // TODO: to check
          vat: quoteLine.tva_rate || VAT[0].value,
          source: SOURCE.QUOTE,
        });
      }
      quoteLine.variants.forEach((variant) => {
        if (variant.is_selected) {
          variant.variant_lines.forEach((variantLine) => {
            if (
              variantLine.type.toLowerCase() === QUOTE_INSTALLER_TYPES.PRODUCT
            ) {
              cartItems.push({
                quantity: variantLine?.quantity,
                sku: variantLine?.product_id,
                quote_line: quoteLine.id,
                quote_number: contextFormatedQuote.number,
                quote_sequence: contextFormatedQuote.sequence,
                variant_line: variantLine.id,
                variant_id: variant.id,
                source: SOURCE.QUOTE,
              });
            }
          });
        }
      });
      quoteLine.options.forEach((option) => {
        if (option.is_selected) {
          option.option_lines.forEach((optionLine) => {
            if (
              optionLine.type.toLowerCase() === QUOTE_INSTALLER_TYPES.PRODUCT
            ) {
              cartItems.push({
                quantity: optionLine?.quantity,
                sku: optionLine?.product_id,
                quote_line: quoteLine.id,
                quote_number: contextFormatedQuote.number,
                quote_sequence: contextFormatedQuote.sequence,
                option_line: optionLine.id,
                option_id: option.id,
                source: SOURCE.QUOTE,
              });
            }
          });
        }
      });
    });

    return cartItems;
  }, [contextFormatedQuote]);

  return {
    formatAddTo,
  };
};

export default useManageQuoteContext;
